import { createActionTypes } from '../../../../util/createActionsHelpers';

export const GET_ARTICLE = createActionTypes('GET_ARTICLE');
